import React from 'react'
import CMSMenuWithLayout from './CMSMenuWithLayout';
import Img from '../../assets/images/background/banner-image-2.jpg'

function Menuone() {
  return (
    <CMSMenuWithLayout
      categoryFilter="breakfast"
      title="BREAKFAST DELIGHTS"
      subtitle="Start Your Day Right"
      bannerImage={Img}
      showOffers={true}
      showReservation={true}
    />
  )
}

export default Menuone